export default __webpack_public_path__ + "static/media/manual-cleaning-03.847d5eaa.png";